import React, { useState } from 'react';
import {
    Typography,
    Box
} from '@mui/material';
import { CreditCardOutlined } from '@mui/icons-material';
import { enqueueSnackbar } from 'notistack';
import { useSelector } from 'react-redux';
import { RootState } from '../../../../../store/store';
import { useCreateVirtualCardMutation, useFetchDataQuery } from '../../../services/services';
import { ConfirmationModal } from '../../../../../components/ConfirmationModal';

// Card service interfaces
interface CreateVirtualCardResponse {
    success: boolean;
    message: string;
}

interface CreateVirtualCardActionProps {
    isOpen: boolean;
    onClose: () => void;
    onSuccess?: () => void;
}

const CreateVirtualCardAction: React.FC<CreateVirtualCardActionProps> = ({ isOpen, onClose, onSuccess }) => {
    const { currentUserState } = useSelector((state: RootState) => state.currentUserState);
    const [loading, setLoading] = useState(false);
    const [createVirtualCard] = useCreateVirtualCardMutation();

    const handleConfirm = async () => {
        try {
            setLoading(true);

            const cardModel = {
                companyId: currentUserState?.companyId
            };

            const result = await createVirtualCard(cardModel);
            const response: CreateVirtualCardResponse | undefined = (result as any).data;

            if (response?.success) {
                enqueueSnackbar(response.message, {
                    variant: 'success'
                });

                // Refresh the card list
                onSuccess?.();
                handleClose();
            } else {
                enqueueSnackbar(response?.message || 'Sanal kart oluşturulurken bir hata oluştu', {
                    variant: 'error'
                });
            }
        } catch (error: any) {
            const errorMessage = error?.error?.message || error?.message || 'Bilinmeyen bir hata oluştu';
            enqueueSnackbar(errorMessage, {
                variant: 'error'
            });
        } finally {
            setLoading(false);
        }
    };

    const handleClose = () => {
        onClose();
    };

    return (
        <ConfirmationModal
            isOpen={isOpen}
            onClose={handleClose}
            onConfirm={handleConfirm}
            title="Sanal Kart Oluştur"
            isLoading={loading}
            confirmButtonText={'Evet'}
            closeButtonText="Hayır"
            optionalWidth="520px"
            customHeaderStyle={{
                icon: (
                    <Box
                        sx={{
                            width: 32,
                            height: 32,
                            borderRadius: 1,
                            bgcolor: 'rgba(255,255,255,0.2)',
                            color: 'white',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                        }}
                    >
                        <CreditCardOutlined sx={{ fontSize: 18 }} />
                    </Box>
                ),
            }}
        >
            <Box sx={{ textAlign: 'center', py: 2 }}>
                <Typography variant="h6" sx={{
                    fontWeight: 700,
                    color: '#1a202c',
                    mb: 1
                }}>
                    Sanal kart oluşturmak istiyor musunuz?
                </Typography>
            </Box>
        </ConfirmationModal>
    );
};

export default CreateVirtualCardAction;
